export const defaultLang = 'en';
export const availableLangs = Object.freeze([defaultLang, 'es', 'zh']);
